import {library} from '@fortawesome/fontawesome-svg-core';

import {
  faCoffee,
  faChild,
  faCircle,
  faArchive,
  faComment,
  faSignInAlt,
  faEyeSlash,
  faEye,
  faStepBackward,
  faStepForward,
  faBars,
  faUserFriends,
  faBookmark,
  faCalendarDay,
  faCalendarAlt,
  faHome,
  faAngleDown,
  faCogs,
  faChartArea,
  faEdit,
  faFileDownload,
  faFileUpload,
  faFile,
  faUndo,
  faPrint,
  faBook,
  faTimes,
  faSignOutAlt,
  faArrowsAltH,
  faWindowClose,
  faSave,
  faBan,
  faSearch,
  faPlus,
  faCheck,
  faHotel,
  faExchangeAlt,
  faTrash,
  faArrowRight,
  faExclamation,
  faUserPlus,
  faPaperclip,
  faComments,
  faCommentDots,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faTachometerAlt,
  faAsterisk,
  faMailBulk,
  faBell,
  faEnvelope,
  faUserTie,
  faSpinner,
  faFilter,
  faUpload,
  faUserTimes,
  faPlusCircle,
  faChevronCircleUp,
  faSync,
  faCheckCircle,
  faKey,
  faUserLock,
  faSyringe,
  faCircleNotch,
  faLocationArrow,
  faShip,
  faSquare,
  faThumbsUp,
  faThumbsDown,
  faEraser,
  faArrowUp,
  faArrowDown,
  faMinusCircle,
  faTimesCircle,
  faCog,
  faBackward,
  faArrowLeft,
  faWrench,
  faFolder,
  faUser,
  faChevronRight,
  faAnchor,
  faChevronDown,
  faArrowCircleUp,
  faLongArrowAltUp,
  faMinus,
  faPencilAlt,
  faMarker,
  faDatabase,
  faCheckDouble,
  faSortAmountUpAlt,
  faSortAmountDownAlt,
  faAlignJustify,
  faEllipsis,
  faAngleLeft,
  faAnglesLeft,
  faAngleRight,
  faAnglesRight,
  faPenToSquare,
  faListCheck,
  faCircleUser,
  faSheetPlastic,
  faFileLines,
  faFilePen,
  faScrewdriverWrench,
  faEllipsisVertical,
  faPen,
  faCirclePlay,
  faMusic,
  faFilePdf,
  faFileExcel,
  faFileWord,
  faImage,
  faCircleXmark,
  faArrowUpFromBracket,
  faClockRotateLeft,
  faRightFromBracket,
  faLock,
  faCircleInfo,
  faInfo,
  faGear,
  faFileInvoice,
  faSun,
  faCloudMoon,
  faMoon,
  faSort,
  faSortUp,
  faSortDown,
  faTableList,
  faCar,
  faPesoSign,
  faReceipt,
  faRectangleList,
  faTruckMoving,
  faScroll,
  faMoneyBill,
  faPercent,
  faXmark,
  faFastForward,
  faFastBackward,
  faChevronLeft,
  faEnvelopeOpenText,
  faClock,
  faRotate,
  faTruck,
  faFileImage,
  faFileImport,
  faRotateLeft,
  faRedo,
  faPaperPlane,
  faSquareArrowUpRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faCopy,
  faFlagCheckered,
  faTruckArrowRight,
  faRepeat,
  faCircleDown,
  faRoute,
  faLocationDot,
  faArrowRightLong,
  faMapLocationDot,
  faGripVertical,
  faBoxOpen,
  faRotateRight,
  faRulerHorizontal,
  faUnderline,
  faStrikethrough,
  faCode,
  faBold,
  faItalic,
  faListUl,
  faListOl,
  faQuoteRight,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faFont,
  faFillDrip,
  faSquarePen,
  faBorderStyle,
  faTable,
  faTableColumns,
  faHeading,
  faCompressAlt,
  faShieldHalved,
  faChevronUp,
  faCircleExclamation,
  faClipboardList,
  faAnglesUp,
  faMapPin,
  faThumbtack,
  faBox,
  faWarehouse,
  faTruckFast,
  faTruckRampBox,
  faLink,
  faClone,
  faUsers,
  faTriangleExclamation,
  faCalendarXmark,
  faClipboard,
  faClipboardCheck,
  faUserCheck,
  faFileSignature,
  faSearchDollar,
  faBookOpenReader,
  faGripHorizontal,
  faTruckFront,
  faBuildingUser,
  faUserClock,
  faBoxesStacked, faDownload,
  faQuestionCircle,
  faCalendarPlus,
  faTextHeight,
  faCircleQuestion,
  faUserShield,
  faFileContract,
  faPaste,
  faStore,
  faList, faThLarge,
  faLayerGroup,
  faShapes,
  faX,
  faFolderOpen,
  faHashtag,
  faFerry, faSquareMinus,
  faUserPen,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCircleCheck, faCircleXmark as faRegularCircleXmark
} from '@fortawesome/free-regular-svg-icons'


export default () => {
  library.add(
    faCoffee, faChild, faCircle, faArchive, faComment, faSignInAlt, faEyeSlash, faEye,
    faStepBackward, faStepForward,
    faBars, faUserFriends, faBookmark, faCalendarDay, faCalendarAlt, faHome, faAngleDown,
    faCogs, faChartArea, faEdit, faBookmark, faFileDownload, faFileUpload, faFile, faUndo,
    faPrint, faBook, faTimes, faSignOutAlt, faArrowsAltH, faWindowClose, faArrowsAltH,
    faSave, faBan, faSearch, faPlus, faCheck, faHotel, faExchangeAlt, faTrash,
    faArrowRight, faExclamation, faComments, faCommentDots, faCaretDown, faCaretUp, faUserPlus,
    faPaperclip, faTachometerAlt, faAsterisk, faMailBulk, faBell, faEnvelope, faUserTie, faSpinner, faFilter,
    faUpload, faUserTimes, faPlusCircle, faChevronCircleUp, faSync, faCheckCircle, faKey,
    faUserLock, faSyringe, faCircleNotch, faLocationArrow, faShip, faSquare, faThumbsUp, faThumbsDown, faEraser,
    faArrowUp, faArrowDown, faMinusCircle, faTimesCircle, faCog, faBackward, faArrowLeft, faArrowCircleUp, faCaretRight,
    faWrench, faFolder, faUser, faChevronRight, faAnchor, faChevronDown, faLongArrowAltUp, faMinus, faPencilAlt, faMarker,
    faDatabase, faCheckDouble, faSortAmountUpAlt, faSortAmountDownAlt,
    faAlignJustify, faEllipsis, faAngleLeft, faAnglesLeft,
    faAngleRight, faAnglesRight, faPenToSquare, faListCheck, faCircleUser,
    faSheetPlastic, faFileLines, faFilePen, faScrewdriverWrench, faEllipsisVertical, faBan, faPen,
    faCirclePlay, faMusic, faFilePdf, faFileExcel, faFileWord, faFile, faImage, faCircleXmark, faArrowUpFromBracket, faKey,
    faClockRotateLeft, faRightFromBracket, faLock, faCircleInfo, faInfo, faGear, faFileInvoice, faSun, faCloudMoon, faMoon,
    faSort, faSortUp, faSortDown, faTableList, faCar, faPesoSign, faReceipt, faRectangleList, faTruckMoving, faScroll, faMoneyBill, faPercent, faXmark,
    faClockRotateLeft, faRightFromBracket, faLock, faCircleInfo, faInfo, faGear, faFileInvoice, faSun, faCloudMoon, faMoon,
    faSort, faSortUp, faSortDown, faTableList, faCar, faPesoSign, faReceipt, faRectangleList, faTruckMoving, faScroll, faMoneyBill,
    faPercent, faFastForward, faFastBackward, faChevronLeft, faEnvelopeOpenText, faClock, faRotate, faTruck, faFileImage, faFileImport, faRotateLeft, faRedo, faFlagCheckered,
    faPaperPlane, faSquareArrowUpRight, faArrowRightToBracket, faCopy, faArrowRightFromBracket, faTruckArrowRight, faRepeat, faCircleDown, faRoute, faLocationDot,
    faArrowRightLong, faMapLocationDot, faGripVertical, faBoxOpen,
    faRotateRight, faRulerHorizontal, faUnderline, faStrikethrough, faCode, faBold,
    faItalic, faListUl, faListOl, faQuoteRight, faAlignLeft, faBoxesStacked,
    faAlignRight, faAlignCenter, faFont, faFillDrip, faShip, faDownload,
    faSquarePen, faBorderStyle, faTable, faTableColumns, faHeading,
    faCompressAlt, faShieldHalved, faChevronUp, faCircleExclamation,
    faClipboardList, faBoxOpen, faAnglesUp, faMapPin, faThumbtack, faBox, faWarehouse, faShip, faTruckFast,
    faTruckRampBox, faLink, faCircleCheck, faClone, faRegularCircleXmark, faUsers, faTriangleExclamation, faCalendarXmark,
    faClipboard, faClipboardCheck, faUserCheck, faFileSignature, faBookOpenReader, faGripHorizontal, faTruckFront, faBuildingUser, faUserClock,
    faQuestionCircle,
    faUserShield, faTextHeight,
    faCalendarPlus,
    faUserShield,
    faFileContract,
    faPaste,
    faStore,
    faList,
    faThLarge,
    faLayerGroup,
    faShapes,
    faX,
    faFolderOpen,
    faHashtag,
    faFerry, faSquareMinus,
    faUserPen,
  )
}
